var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConveyorLabelScan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M15.4 17.7c-.3 0-.5-.2-.5-.5V8h-11v9.1c0 .3-.2.5-.5.5s-.5-.2-.5-.5V7h13v10.2c0 .3-.2.5-.5.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M12.9 10.7H10c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.9c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3FE7E7",
  d: "M19.6 8.1c-.3 0-.5-.2-.5-.5V4.7h-2.7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3.2c.3 0 .5.2.5.5v3.4c0 .3-.3.5-.5.5M1.1 8.1c-.3 0-.5-.2-.5-.5V4.2c0-.3.2-.5.5-.5h3.2c.3 0 .5.2.5.5s-.3.5-.5.5H1.6v2.9c0 .3-.2.5-.5.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0072CC",
  d: "M22.7 17.9H4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h18.7c.3 0 .5.2.5.5s-.2.5-.5.5M12.5 22.3h-9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h9c.3 0 .5.2.5.5s-.2.5-.5.5M18 22.3h-3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H18c.3 0 .5.2.5.5s-.3.5-.5.5M22.9 22.3h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M3.6 22.3c-1.5 0-2.7-1.2-2.7-2.7s1.2-2.7 2.7-2.7 2.7 1.2 2.7 2.7-1.2 2.7-2.7 2.7m0-4.4c-.9 0-1.7.8-1.7 1.7s.8 1.7 1.7 1.7 1.7-.8 1.7-1.7-.7-1.7-1.7-1.7M22.7 22.3c-1.5 0-2.7-1.2-2.7-2.7s1.2-2.7 2.7-2.7 2.7 1.2 2.7 2.7-1.2 2.7-2.7 2.7m0-4.4c-.9 0-1.7.8-1.7 1.7s.8 1.7 1.7 1.7 1.7-.8 1.7-1.7-.8-1.7-1.7-1.7"
})));
export default SvgConveyorLabelScan;